/**
 * Toasts for the MAPS surface, on MJ's DOM-based MJNotificationService
 * (@memberjunction/ng-notifications). Replaces the package's own ToastService +
 * <maps-toast> (deleted 2026-09-21): same 2.6 s auto-dismiss from the STN
 * mockup, and MJ's toast HTML-escapes the message, which ours did not. Being
 * DOM-based it needs no NgZone wrapping — Apollo callbacks outside the zone
 * were the reason ToastService wrapped everything in zone.run.
 */
import { MJNotificationService } from '@memberjunction/ng-notifications';

const TOAST_DURATION_MS = 2600;

export function NotifySuccess(message: string): void {
    MJNotificationService.Instance.CreateSimpleNotification(message, 'success', TOAST_DURATION_MS);
}

export function NotifyError(message: string): void {
    MJNotificationService.Instance.CreateSimpleNotification(message, 'error', TOAST_DURATION_MS);
}
